import React, { useContext } from 'react';

import {
  DebtorList, ModalFormHeader, NoAssetsDisplay
} from '..';
import { DebtorsContext } from '../../context';

export function WillDebtors() {
  const { debtors } = useContext(DebtorsContext);
  
  return (
    <div className="form-container">
      <ModalFormHeader
        icon="money_off"
        header="Debt Forgiveness"
      />
      { debtors.length > 0 ? (
        <DebtorList debtors={debtors} />
      ) : (
        <NoAssetsDisplay 
          compact
          icon="info" 
          title="No Debtors" 
          description="Add individuals or entities you wish to forgive debts for." />
      )}
    </div>
  );
}